/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import PatientsDataContent from "components/content/PatientsDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";

/**
 * Patient management page displaying patient list and search functionality.
 * 
 * Features:
 * - Paginated patient data table with search and filters
 * - Patient demographic information display
 * - Quick actions (view, edit, delete patients)
 * - Integration with patient hub for detailed patient records
 * - Role-based access control for patient data
 * 
 * @returns Patients list page component
 */
const PatientsPage: FC = () => {
  return (
    <DefaultDashboardLayout>
      <PatientsDataContent />
    </DefaultDashboardLayout>
  );
};

export default PatientsPage;

